import * as React from 'react';
import { Parallax } from 'react-scroll-parallax';

import Layout from '../../components/Layout/index';
import TitleBar from '../../components/TitleBar';
import Button from '../../components/Button';

import './style.scss';

const ReportsPage = () => {
  const reports = [
    {
      title: 'Professional Standards Councils combined annual report, 20-21',
      link: '/annual-report-2020-2021/pdfs/Professional_Standards_Councils_Annual_Report_2020-21.pdf',
      filesize: '2.6MB',
      color: 'secondary',
      buttonColor: 'tertiary',
    },
    {
      title: 'Professional Standards Council (QLD) financial addendum, 20-21',
      link: '/annual-report-2020-2021/pdfs/Professional_Standards_Councils_Financial_Statement_QLD_2020-21.pdf',
      filesize: '1.4MB',
      color: 'secondary',
      buttonColor: 'tertiary',
    },
    {
      title: 'Professional Standards Council (SA) financial addendum, 20-21',
      link: '/annual-report-2020-2021/pdfs/Professional_Standards_Councils_Financial_Statement_SA_2020-21.pdf',
      filesize: '3.5MB',
      color: 'secondary',
      buttonColor: 'tertiary',
    },
    {
      title: 'Professional Standards Council (VIC) financial addendum, 20-21',
      link: '/annual-report-2020-2021/pdfs/Professional_Standards_Councils_Financial_Statement_VIC_2020-21.pdf',
      filesize: '2.3MB',
      color: 'secondary',
      buttonColor: 'tertiary',
    },
    {
      title: 'Professional Standards Council (WA) financial addendum, 20-21',
      link: '/annual-report-2020-2021/pdfs/Professional_Standards_Councils_Financial_Statement_WA_2020-21.pdf',
      filesize: '6MB',
      color: 'secondary',
      buttonColor: 'tertiary',
    },
    {
      title: 'Download All Reports',
      link: '/annual-report-2020-2021/pdfs/all.zip',
      filesize: '13.5MB',
      color: 'tertiary',
      buttonColor: 'light-teal',
    },
  ];

  return (
    <Layout pageTitle="Reports">
      <TitleBar title="Reports" />
      <section className="l-reports">
        <Parallax className="background" y={[-30, 30]}>
          <div className="bg1" />
        </Parallax>
        <div className="container">
          <div className="grid">
            {reports.map((report, i) => (
              <div
                key={i}
                className={`card is-${report.color}`}
                data-sal="slide-up"
                data-sal-duration="1000"
                data-sal-delay="300"
                data-sal-easing="ease"
              >
                <div className="title">{report.title}</div>
                <Button color={report.buttonColor} openInNewTab label={`Download (${report.filesize})`} to={report.link} icon="document" 
                  // download
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ReportsPage;
